import { locations } from './locations.js';

window.callMap = () => {
    if ($('.location-tabs') || $('#contact-map')) {
        locations();
    }
}

window.initMap = (bbLocations = false, locationMap, coordX = 0, coordY = 0) => {
    let map, marker;

    if (document.getElementById(locationMap)) {
        const myLatLng = { lat: coordX, lng: coordY };
        map = new google.maps.Map(document.getElementById(locationMap), {
            center: myLatLng,
            zoom: 8,
            disableDefaultUI: true,
            zoomControl: true,
            styles: [{
                stylers: [
                    { gamma: 3.0 }, { saturation: -100 }
                ]
            }]
        });
        new google.maps.Marker({
            position: myLatLng,
            map
        });

        if (bbLocations) {
            map = new google.maps.Map(document.getElementById(locationMap), {
                zoom: 3,
                center: {
                    lat: 60.15141990000001,
                    lng: 24.880271799999946
                },
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                disableDefaultUI: true,
                zoomControl: true,
                styles: [{
                    stylers: [
                        { gamma: 3.0 }, { saturation: -100 }
                    ]
                }]
            })

            bbLocations.forEach(location => {
                marker = new google.maps.Marker({
                    position: new google.maps.LatLng(location[0], location[1]),
                    map: map
                })
                marker.setMap(map);
            })
        }
    };

    if (document.getElementById('contact-map')) {
        const myLatLng = { lat: 60.151658, lng: 24.8779144 };
        map = new google.maps.Map(document.getElementById('contact-map'), {
            center: myLatLng,
            zoom: 13,
            disableDefaultUI: true,
            zoomControl: true,
            styles: [{
                stylers: [
                    { gamma: 3.0 }, { saturation: -100 }
                ]
            }]
        });
        new google.maps.Marker({
            position: myLatLng,
            map
        });
    }
}